"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaggedSelectField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ChipListMore_1 = require("../ChipListMore");
var TextField_1 = require("../../atoms/TextField");
var styles_1 = require("./styles");
// TODO: consider using a custom function to map selected values into this default format
// TODO: list option can probably be updated with "label" instead of text
exports.TaggedSelectField = react_1.default.memo(function (_a) {
    var options = _a.options, maxNumberOfItems = _a.maxNumberOfItems, SelectProps = _a.SelectProps, rest = __rest(_a, ["options", "maxNumberOfItems", "SelectProps"]);
    var classes = (0, styles_1.useStyles)();
    var renderValue = (0, react_1.useCallback)(function (selected) {
        var items = options
            .filter(function (option) { return selected.includes(option.value); })
            .map(function (_a) {
            var text = _a.text, value = _a.value;
            return ({ label: text || value });
        });
        return ((0, jsx_runtime_1.jsx)(ChipListMore_1.ChipListMore, { className: classes.chipRoot, items: items, justifyContent: "flex-start", maxNumberOfItems: maxNumberOfItems }));
    }, [maxNumberOfItems, options, classes]);
    var menuItems = (0, react_1.useMemo)(function () {
        return options &&
            options.map(function (_a) {
                var value = _a.value, text = _a.text;
                return ((0, jsx_runtime_1.jsx)(core_1.MenuItem, __assign({ value: value }, { children: text }), value));
            });
    }, [options]);
    return ((0, jsx_runtime_1.jsx)(TextField_1.TextField, __assign({ SelectProps: __assign(__assign({}, SelectProps), { multiple: true, renderValue: renderValue }) }, rest, { select: true }, { children: menuItems })));
});
